import React from "react";
import TitleSection from "../../components/TitleSection";
import { SwapOutlined } from "@ant-design/icons";
import ExchangeBoardCardRevamp from "../dashboard/ExchangeBoardCardRevamp";

const ExchangeBoard: React.FC = () => {
    return (
        <div style={{ paddingBottom: '20px' }}>
            <TitleSection
                title="Request Board"
            />
            <div style={{ padding: 0 }}>
                <ExchangeBoardCardRevamp />
            </div>
        </div>
    );
};

export default ExchangeBoard;